export { DMS_MODULE } from '../constants';
export const NAME = 'WmsJobController';
export const API_NAME = 'WmsJobController';
export const CRUMB_LABEL_KEY = 'WmsJobController';
